import Assignment from '../../../assignments';
import { withAuth } from '../../../auth/withAuth';

const WithAuthAssignment = withAuth(Assignment);

export default WithAuthAssignment;
